import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const icons = {
    AccountBalanceWalletIcon,
};

const paymentHistory = {
    id: 'payment_history',
    type: 'group',
    children: [
        {
            id: 'Payment_History',
            title: 'Payment History',
            type: 'item',
            url: '/payment_history',
            icon: icons.AccountBalanceWalletIcon,
        }
    ]
};

export default paymentHistory;